import React, { useEffect } from "react";
import { Swiper } from "venuescanner-js/vanilla/widgets/swiper";
import { lazyload } from "venuescanner-js/vanilla/widgets/lazyload";

import "venuescanner-scss/stylesheets/widgets/galleryNew.scss";

const Carousel = ({ id, altPrefix, images, isMobile }) => {
  // this carousel is new but just a template around the legacy version, needs rebuilding from scratch when we get a chance
  useEffect(() => {
    try {
      const swipe = new Swiper(`#gallery-${id}`);
      //   window.gallery = new Swiper('.swiper--mobile')
    } catch (error) {
      console.error("gallery load error:", error);
    }
  }, []);

  return (
    <div
      className={`carousel ux-gallery2 ${
        isMobile ? "swiper" : "swiper swiper--mobile"
      }`}
      id={`gallery-${id}`}
      ref={(el) => {
        lazyload.init(el);
      }}
    >
      {images.length > 1 && (
        <div className="gallery-button-container">
          <div>
            <button className="ux-gallery2-left swiper-left"></button>
            <button className="ux-gallery2-right swiper-right"></button>
          </div>
        </div>
      )}

      <div className="swiper-pane-container">
        <div className="ux-gallery2-cont swiper-pane">
          {images.map((image, index) => (
            <figure key={image + index} className="ux-gallery2-img-off">
              <img
                className="carousel__image"
                data-src={image.path}
                scoller-detect-parent="yes"
                alt={`${altPrefix} image number ${index + 1}`}
              />
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
